import React from "react";
import PropTypes from "prop-types";
import { filter, last, split, startsWith } from "lodash";
import { P, StyledLink } from "orcs-design-system";
import { TAGS } from "src/consts/comments";
import { teamDetailsPath } from "../../util/routing";
import AuthorTitle from "../AuthorTitle";
import GenericHistoryContent from "./GenericHistoryContent";

const GROUP_ID_PREFIX = TAGS.GROUP_ID("");

const GroupUpdateHistoryContent = ({ comment, groupsMap }) => {
  const { tags, content, authorTitle } = comment;

  if (content.includes("GROUP_LINK_TOKEN")) {
    // Extract all GROUP_ID tags
    const groupIdTags = filter(tags, (t) => startsWith(t, GROUP_ID_PREFIX));
    const groupIds = groupIdTags.map((tag) => last(split(tag, ":")));

    // Split content by GROUP_LINK_TOKEN
    const splitContent = split(content, "GROUP_LINK_TOKEN");

    // Check if we have the expected number of group IDs and all groups exist
    const expectedGroupCount = splitContent.length - 1;
    const allGroupsExist =
      groupIds.length > 0 &&
      groupIds.length === expectedGroupCount &&
      groupIds.every((id) => groupsMap[id]);

    if (!allGroupsExist) {
      // If any group is missing, render as generic content with group IDs
      let genericContent = "";
      splitContent.forEach((part, index) => {
        genericContent += part;
        if (index < groupIds.length) {
          genericContent += groupIds[index] || "";
        }
      });
      return (
        <GenericHistoryContent
          content={genericContent}
          authorTitle={authorTitle}
        />
      );
    }

    // Render content with links
    return (
      <>
        <P>
          {splitContent.map((part, index) => (
            <React.Fragment key={`${part}-${groupIds[index] || index}`}>
              {part}
              {index < groupIds.length && groupsMap[groupIds[index]] && (
                <StyledLink to={teamDetailsPath(groupsMap[groupIds[index]])}>
                  {groupsMap[groupIds[index]].name}
                </StyledLink>
              )}
            </React.Fragment>
          ))}
        </P>
        <AuthorTitle action="Changed" authorTitle={authorTitle} />
      </>
    );
  }

  return <GenericHistoryContent content={content} authorTitle={authorTitle} />;
};

GroupUpdateHistoryContent.propTypes = {
  comment: PropTypes.object,
  groupsMap: PropTypes.object,
};

export default GroupUpdateHistoryContent;
